export default __webpack_public_path__ + "static/media/812.fbd56cef.jpg";